// tableData.js

const columnsStructureHead = [
  { id: 'sn', label: 'SN.', minWidth: 150 },
  { id: 'abbr', label: 'Group Abr.', minWidth: 190 },
  { id: 'fullName', label: 'Group Full Name', minWidth: 250 },
  { id: 'leader', label: 'Team Leader', minWidth: 250 },
];

const rowsStructureHead = [
  {
    sn: '1.',
    abbr: 'Head/Director',
    fullName: 'Head/Director',
    leader: 'Dr. V.S. Prasad',
  },
  {
    sn: '2.',
    abbr: 'DAE',
    fullName: 'Data Assimilation & Ensembles',
    leader: 'Dr. John P George',
  },
  {
    sn: '3.',
    abbr: 'MD',
    fullName: 'Model Development',
    leader: 'Dr. Saji Mohandas',
  },
  {
    sn: '4.',
    abbr: 'CAI',
    fullName: 'Computer & AI',
    leader: 'Dr. Preveen Kumar D.',
  },
  {
    sn: '5.',
    abbr: 'HPCI',
    fullName: 'HPC & Infrastructure',
    leader: 'Dr. B. Athiyaman',
  },
  {
    sn: '6.',
    abbr: 'CBT',
    fullName: 'Capacity Building & Training',
    leader: 'Dr. Ashish Routray',
  },
  {
    sn: '7.',
    abbr: 'BCWC',
    fullName: 'BIMSTEC Center for Weather & Climate',
    leader: 'Dr. Raghavendra Ashrit',
  },
  {
    sn: '8.',
    abbr: 'ADMIN',
    fullName: 'Administration',
    leader: 'Mr. Biswajit Guha',
  },
];

// groupSubHeadData.js
const columnsSubStructureHead = [
  { id: 'sn', label: 'SN.', minWidth: 150 },
  { id: 'abbr', label: 'Group Abr.', minWidth: 190 },
  { id: 'section', label: 'Section Name', minWidth: 300 },
  { id: 'leader', label: 'Team Leader', minWidth: 250 },
];

const rowsSubStructureHead = [
  {
    sn: '1.',
    abbr: 'DRP',
    section: 'Data Reception & Processing',
    leader: 'Dr. S. Indira Rani',
  },
  {
    sn: '2.',
    abbr: 'DA-1',
    section: 'Data Assimilation-1 (NCUM/NEPS)',
    leader: 'Dr. Imran Ali Momin',
  },
  {
    sn: '3.',
    abbr: 'DA-2',
    section: 'Data Assimilation-2 (NGFS)',
    leader: 'Dr. S. Indira Rani',
  },
  {
    sn: '4.',
    abbr: 'MEDA',
    section: 'Model Evaluation, Diagnostics & Applications',
    leader: 'Dr. Anumeha Dube',
  },
  {
    sn: '5.',
    abbr: 'OM',
    section: 'Ocean Modelling',
    leader: 'Dr. D.K. Mohapatra',
  },
  {
    sn: '6.',
    abbr: 'AM',
    section: 'Atmospheric Modelling',
    leader: 'Dr. A. Jayakumar',
  },
  {
    sn: '7.',
    abbr: 'CM',
    section: 'Coupled Modelling',
    leader: 'Dr. Akhilesh Kumar Mishra',
  },
  {
    sn: '8.',
    abbr: 'RSAI',
    section: 'Remote Sensing & Artificial Intelligence',
    leader: 'Dr. M.N. Raghavendra Sreevathsa',
  },
];

export {
  columnsSubStructureHead,
  rowsSubStructureHead,
  columnsStructureHead,
  rowsStructureHead,
};
